import React, {Component} from 'react';
import PropTypes from 'prop-types';

import * as d3 from 'd3';
import _ from 'lodash';

import {geoUtils} from '../utils/geo-utils';

class StateMapShapes extends Component {

  shouldComponentUpdate(nextProps, nextState) {
    const widthDifferent = nextProps.width !== this.props.width;
    const heightDifferent = nextProps.height !== this.props.height;
    const stateDifferent = nextProps.stateFips !== this.props.stateFips;
    const dataDifferent = nextProps.data !== this.props.data;
    const dimXDiff = nextProps.dimX !== this.props.dimX;
    const dimYDiff = nextProps.dimY !== this.props.dimY;

    return widthDifferent || heightDifferent || stateDifferent || dataDifferent || dimXDiff || dimYDiff;
  }

  getBivariateScale() {
    const props = this.props;

    const getValue = d => _.get(props.dict, [d.id], {});
    const scale = geoUtils.createBivariateScale(props.data, props.dimX, props.dimY);

    return d => {
      return scale(getValue(d));
    }
  }

  getHeatScale() {
    const props = this.props;

    const getValue = d => _.get(props.dict, [d.id, props.dimX], 0);

    const valueX = row => _.get(row, props.dimX, 0);
    const valuesX = _.map(props.data, valueX);

    const scale = d3.scaleLinear()
      .domain([0, d3.mean(valuesX), d3.max(valuesX)])
      .range(['#e8e8e8', '#b0d5df', '#64acbe']);

    return d => {
      return scale(getValue(d));
    }
  }

  render() {
    const paths = geoUtils.getMercatorStateCountyPaths(this.props.stateFips, this.props.width, this.props.height);

    const scale = this.props.useHeatScale ? this.getHeatScale() : this.getBivariateScale();

    return (
      <g className="StateMapShapes">
        {paths.map(d => {
          return (
            <path
              key={d.id}
              d={d.path}
              fill={scale(d)}
            ></path>
          );
        })}
      </g>
    )
  }
}

StateMapShapes.propTypes = {
  stateFips: PropTypes.number,
  width: PropTypes.number,
  height: PropTypes.number,
  data: PropTypes.array,
  dimX: PropTypes.string,
  dimY: PropTypes.string,
  useHeatScale: PropTypes.bool
};


export default StateMapShapes


// WEBPACK FOOTER //
// ./src/charts/StateMap/StateMapShapes.js